module.exports = __webpack_public_path__ + "call.png?4052211bc603be56833085c09dde6f64";